<template>
  <li class="history-item">
    <div class="history-item-date ms-help">
      {{ parseDateTime(action.time) }}
    </div>
    <div class="history-item-info ms-text">
      <!-- <div class="history-item-contract ms-small-head" v-if="all && action.contract_code">
        {{ action.contract_code }}. {{ action.contract_name }}
      </div> -->
      <div class="histy-item-title">
        <span v-html="action.user_string" />
      </div>
    </div>
  </li>
</template>

<script>
import { parseDateTime } from '@/utils'

export default {
  props: ['action', 'all'],
  methods: {
    parseDateTime
  }
}
</script>

<style lang="less">
.history-item {
  display: flex;

  &:not(:first-child) {
    margin-top: 8px;
  }

  &-date {
    width: 64px;
    flex-shrink: 0;
    margin-right: 16px;
  }
}
</style>
